export default __webpack_public_path__ + "static/hero-bg-desk-374bd7535d6dce28d37058c305680ae4.png";